/* eslint-disable */
import React, { useState } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import Select from 'react-select';
import './ hiringForecast.scss';
import StaffingProjectionChart from '../StaffingProjections/staffingProjections.js';
import BenchReleaseForecast from '../BenchReleaseForecast/benchReleaseForecast.js';

const skillGroups = [
  { label: 'FE Dev', high: 5, medium: 3, junior: 7 },
  { label: 'BE Dev', high: 4, medium: 6, junior: 4 },
  { label: 'PMO', high: 1, medium: 1, junior: 1 },
  { label: 'Quality', high: 6, medium: 5, junior: 5 },
  { label: 'Design', high: 3, medium: 3, junior: 3 },
  { label: 'Finance', high: 2, medium: 3, junior: 2 },
  { label: 'Other', high: 2, medium: 2, junior: 2 },
];

const filterOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'q3-q4', label: 'Q3 + Q4' },
];

const HiringForecast = () => {
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);
  const [selectedSkillGroup, setSelectedSkillGroup] = useState(null);

  const barData = {
    labels: skillGroups.map((group) => group.label),
    datasets: [
      {
        label: 'High Experience',
        data: skillGroups.map((group) => group.high),
        backgroundColor: '#5749E2',
        borderRadius: 10,
        barThickness: 35,
        stack: 'stack1',
        width: '32px',
      },
      {
        label: 'Medium Experience',
        data: skillGroups.map((group) => group.medium),
        backgroundColor: '#848AF5',
        borderRadius: 10,
        barThickness: 35,
        stack: 'stack1',
        width: '32px',
      },
      {
        label: 'Junior',
        data: skillGroups.map((group) => group.junior),
        backgroundColor: '#C8D1FD',
        borderRadius: 10,
        barThickness: 35,
        stack: 'stack1',
        width: '32px',
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        titleColor: '#1D1B20',
        bodyColor: '#888888',
        borderColor: '#DDD',
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          callback: function (value, index, ticks) {
            return skillGroups[index].label;
          },
          maxRotation: 90,
          minRotation: 90,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            if ([0, 5, 10, 15, 20].includes(value)) return value;
          },
          stepSize: 5,
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
          borderDash: [5, 5],
        },
      },
    },
  };

  const handleBarClick = (_, elements) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      setSelectedSkillGroup(skillGroups[index]);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection:'column',
      gap:'16px'
    }}>
      <StaffingProjectionChart />
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '16px',
          padding: '20px',
          background:
            'linear-gradient(92.32deg, rgba(107, 92, 232, 0.2) 9.69%, rgba(2, 233, 249, 0.1) 114.95%, rgba(181, 206, 68, 0.1) 165.98%)',
        }}
      >
        <div className="staffing-projection">
          <div
            className="header"
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              width: '100%',
              marginLeft: '0',
            }}
          >
            <h2 style={{ margin: '-14px', fontSize: '20px', color: '#333' }}>
              Hiring Forecast - Experience Distribution
            </h2>
          </div>

          <div
            className="header-row"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <p className="date">
              December 2024
            </p>
            <div
              className="filter-container"
              style={{ marginLeft: 'auto', marginTop: '0' }}
            >
              <Select
                options={filterOptions}
                value={selectedFilter}
                onChange={(selected) => setSelectedFilter(selected)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: '200px',
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: '#F1F5F8',
                    borderRadius: '4px',
                    borderColor: '#F1F5F8',
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: '#000',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    backgroundColor: '#F1F5F8',
                  }),
                }}
              />
            </div>
          </div>
          <div className="bar-chart-container">
            <div className="chart-wrapper">
              <Bar
                data={barData}
                options={barOptions}
                onClick={handleBarClick}
              />
            </div>
          </div>
          <div
            className="legend-container"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '20px',
            }}
          >
            <div
              className="legend-items"
              style={{ display: 'flex', gap: '16px', alignItems: 'center' }}
            >
              <div
                className="legend-item"
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <div
                  className="legend-box"
                  style={{
                    backgroundColor: '#5749E2',
                    width: '4px',
                    height: '20px',
                    borderRadius: '2px',
                  }}
                ></div>
                <span style={{ fontSize: '12px', color: '#555' }}>
                  High Experience
                </span>
              </div>
              <div
                className="legend-item"
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <div
                  className="legend-box"
                  style={{
                    backgroundColor: '#848AF5',
                    width: '4px',
                    height: '20px',
                    borderRadius: '2px',
                  }}
                ></div>
                <span style={{ fontSize: '12px', color: '#555' }}>
                  Medium Experience
                </span>
              </div>
              <div
                className="legend-item"
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <div
                  className="legend-box"
                  style={{
                    backgroundColor: '#C8D1FD',
                    width: '4px',
                    height: '20px',
                    borderRadius: '2px',
                  }}
                ></div>
                <span style={{ fontSize: '12px', color: '#555' }}>Junior</span>
              </div>
            </div>
            <p
              className="legend-note"
              style={{
                margin: '0',
                textAlign: 'right',
                fontSize: '12px',
                color: '#555',
              }}
            >
              Note: * denotes multi-skilled employees
            </p>
          </div>

          {selectedSkillGroup && (
            <div className="skill-breakdown">
              <h3>Skill Breakdown: {selectedSkillGroup.label}</h3>
              <Doughnut
                data={{
                  labels: ['High', 'Medium', 'Junior'],
                  datasets: [
                    {
                      data: [
                        selectedSkillGroup.high,
                        selectedSkillGroup.medium,
                        selectedSkillGroup.junior,
                      ],
                      backgroundColor: ['#7B61FF', '#A59FFF', '#D3CCFF'],
                    },
                  ],
                }}
              />
            </div>
          )}
        </div>
        <BenchReleaseForecast />
      </div>
    </div>
  );
};

export default HiringForecast;
